(function () {
    'use strict';

    function addQuestion(questionViewModelConfigurationService, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/addQuestion.html',
            scope: {
                toggleIsActive: '&',
                addNewQuestion: '&'
            },
            link: function (scope, element, attrs) {
                scope.questionTypes = questionViewModelConfigurationService.questionTypes;
                scope.model = {
                    newQuestionType: questionViewModelConfigurationService.questionTypes[0].$type,
                    titleAndPrompt: ''
                };

                scope.addQuestion = function () {
                    $timeout(function () {
                        var newQuestion = questionViewModelConfigurationService.buildQuestion(scope.model.newQuestionType,
                            scope.model.titleAndPrompt);
                        scope.addNewQuestion()(newQuestion);
                        scope.toggleIsActive()();
                    }, 0);
                }

                scope.close = function () {
                    scope.toggleIsActive()();
                    scope.model.titleAndPrompt = '';
                    scope.newQuestionType = null;
                }
            }
        };
    }

    addQuestion.$inject = ['questionViewModelConfigurationService', '$timeout'];

    angular.module('ecap.common').directive('addQuestion', addQuestion);
})();

